// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2710%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M22.6066 12H1.3934%27 stroke=%27%23202842%27 stroke-width=%271.875%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M12 1.39343V22.6066%27 stroke=%27%23202842%27 stroke-width=%271.875%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2710%27 viewBox=%270 0 18 18%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M16.5 16.5L1.5 1.5%27 stroke=%27%23202842%27 stroke-width=%271.875%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M16.5 1.5L1.5 16.5%27 stroke=%27%23202842%27 stroke-width=%271.875%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confidentiality_container_confidentiality__\\+5zHn {
  width: 60%;
  margin-top: 3%;
  margin-left: 15%;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: center;
}


.confidentiality_container_questions__f-Lot {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: center;
  align-items: center;
  align-self: center;
}


.confidentiality_question_div__S-0vF {
  border: 1px solid var(--hsrcDarkBlue);
  border-radius: 5px;
  margin-bottom: 10px;
  /* max-width: 75%; */
  display: flex;
  flex: 1 1;
  padding: 10px;
}


.confidentiality_answer_div__zDDEr {
  font-size: 16px;
  color: var(--hsrcMidBlue);
  display: flex;
  flex-direction: row;
  flex: 1 1;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  align-self: flex-start;
  /* border: 0.6px solid  var(--hsrcDarkBlue); */
  border-radius: 5px;
  margin-bottom: 10px;
  width: 70%;
  padding: 10px;
}

.confidentiality_faqs__5AWNM {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
}


details summary {
  cursor: pointer;
  margin-bottom: 0;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

details summary::-webkit-details-marker {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: transparent;
  background-size: 100% 100%;
  margin-right: 18px;
  width: 16px;
  height: 16px;
  transform: translateY(1.5px);
}

details[open] summary {
  margin-bottom: 10px;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  color: var(--hsrcOrange);
}

details[open] summary::-webkit-details-marker {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  /* color: var(--hsrcOrange); */
  background-size: 100% 100%;
  margin-right: 20px;
  width: 12px;
  height: 12px;
  transform: translateY(1px);

}

details summary {
  outline: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/ConfidentialityQuestions/confidentiality.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,SAAO;EACP,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAA+Y;AACjZ;;AAEA;EACE,yDAA+Y;EAC/Y,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yDAA8Y;EAC9Y,wBAAwB;AAC1B;;AAEA;EACE,yDAA8Y;EAC9Y,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;;AAE5B;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".container_confidentiality {\r\n  width: 60%;\r\n  margin-top: 3%;\r\n  margin-left: 15%;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n}\r\n\r\n\r\n.container_questions {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: center;\r\n  align-self: center;\r\n}\r\n\r\n\r\n.question_div {\r\n  border: 1px solid var(--hsrcDarkBlue);\r\n  border-radius: 5px;\r\n  margin-bottom: 10px;\r\n  /* max-width: 75%; */\r\n  display: flex;\r\n  flex: 1;\r\n  padding: 10px;\r\n}\r\n\r\n\r\n.answer_div {\r\n  font-size: 16px;\r\n  color: var(--hsrcMidBlue);\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: flex-start;\r\n  align-self: flex-start;\r\n  /* border: 0.6px solid  var(--hsrcDarkBlue); */\r\n  border-radius: 5px;\r\n  margin-bottom: 10px;\r\n  width: 70%;\r\n  padding: 10px;\r\n}\r\n\r\n.faqs {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n\r\ndetails summary {\r\n  cursor: pointer;\r\n  margin-bottom: 0;\r\n  list-style-image: url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.6066 12H1.3934' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 1.39343V22.6066' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n}\r\n\r\ndetails summary::-webkit-details-marker {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.6066 12H1.3934' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 1.39343V22.6066' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n  color: transparent;\r\n  background-size: 100% 100%;\r\n  margin-right: 18px;\r\n  width: 16px;\r\n  height: 16px;\r\n  transform: translateY(1.5px);\r\n}\r\n\r\ndetails[open] summary {\r\n  margin-bottom: 10px;\r\n  list-style-image: url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.5 16.5L1.5 1.5' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M16.5 1.5L1.5 16.5' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n  color: var(--hsrcOrange);\r\n}\r\n\r\ndetails[open] summary::-webkit-details-marker {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.5 16.5L1.5 1.5' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M16.5 1.5L1.5 16.5' stroke='%23202842' stroke-width='1.875' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n  /* color: var(--hsrcOrange); */\r\n  background-size: 100% 100%;\r\n  margin-right: 20px;\r\n  width: 12px;\r\n  height: 12px;\r\n  transform: translateY(1px);\r\n\r\n}\r\n\r\ndetails summary {\r\n  outline: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_confidentiality": `confidentiality_container_confidentiality__+5zHn`,
	"container_questions": `confidentiality_container_questions__f-Lot`,
	"question_div": `confidentiality_question_div__S-0vF`,
	"answer_div": `confidentiality_answer_div__zDDEr`,
	"faqs": `confidentiality_faqs__5AWNM`
};
export default ___CSS_LOADER_EXPORT___;
